import { NgModule } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { LayoutPageComponent } from './layout-page/layout-page.component';
import { LayoutContentComponent } from './layout-content/layout-content.component';
import { LayoutButtonsComponent } from './layout-buttons/layout-buttons.component';
import { LayoutHeaderComponent } from './layout-header/layout-header.component';
import { I18nModule } from '@shared/i18n/i18n.module';
import { RouterModule } from '@angular/router';
import { CompatibilityComponent } from './layout-page/compatibility/compatibility.component';
import { LayoutFooterComponent } from './layout-footer/layout-footer.component';
import { ColorSchemeMiniPickerComponent } from './color-scheme-mini-picker/color-scheme-mini-picker.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { LanguageButtonComponent } from './language-button/language-button.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    MatMenuModule,
    MatIconModule,
    AsyncPipe,
],
  declarations: [
    LayoutPageComponent,
    LayoutContentComponent,
    LayoutButtonsComponent,
    LayoutHeaderComponent,
    LayoutFooterComponent,
    CompatibilityComponent,
    ColorSchemeMiniPickerComponent,
    LanguageButtonComponent,
  ],
  exports: [
    LayoutPageComponent,
    LayoutContentComponent,
    LayoutButtonsComponent,
    LayoutHeaderComponent,
  ],
})
export class LayoutModule { }
